import React from "react";
import { secciones } from "../../../datos";

export function Cobertura() {
  return (
    <section className="py-24 bg-[#FBFAFA] relative overflow-hidden">
      <div className="absolute top-0 left-0 w-80 h-80 bg-[#151C84]/4 rounded-full -translate-x-1/3 -translate-y-1/3 blur-3xl pointer-events-none" />

      {secciones[0].cobertura?.map((item, index) => (
        <div className="container mx-auto px-4 relative z-10" key={index}>
          {/* Header */}
          <div className="text-center mb-16">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#151C84]/10 text-[#151C84] text-sm font-bold rounded-full mb-6 border border-[#151C84]/15">
              <span className="w-2 h-2 rounded-full bg-[#C81416]" />
              Cobertura Nacional
            </span>
            <h2
              className="text-4xl md:text-5xl font-extrabold text-[#151C84] mb-4"
              data-aos="fade-up"
            >
              {item.subtitle}
            </h2>
            <div className="flex items-center justify-center gap-2 mt-4">
              <div className="h-0.5 w-12 bg-[#C81416] rounded-full" />
              <div className="h-1.5 w-1.5 rounded-full bg-[#C81416]" />
              <div className="h-0.5 w-12 bg-[#C81416] rounded-full" />
            </div>
          </div>

          {/* Image grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 xl:gap-8">
            {item.list?.map((zone, i) => {
              const { image, title } = zone;
              const accent = i === 1 ? "#C81416" : "#151C84";
              return (
                <div
                  key={i}
                  className="group relative h-80 md:h-96 rounded-2xl overflow-hidden shadow-[0_4px_20px_rgba(21,28,132,0.12)] hover:shadow-[0_12px_48px_rgba(21,28,132,0.25)] transition-all duration-500 hover:-translate-y-2"
                  data-aos="zoom-in"
                  data-aos-delay={i * 120}
                >
                  {/* Image */}
                  <img
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    src={image}
                    alt={title}
                  />

                  {/* Gradient */}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0d125c]/95 via-[#151C84]/40 to-transparent transition-opacity duration-300" />

                  {/* Zone number badge */}
                  <div
                    className="absolute top-4 right-4 w-10 h-10 rounded-xl flex items-center justify-center text-white font-extrabold text-sm shadow-lg"
                    style={{ background: accent }}
                  >
                    {i + 1}
                  </div>

                  {/* Content */}
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                    <div className="flex items-center gap-3 mb-2">
                      <div className="w-6 h-0.5 rounded-full" style={{ background: accent }} />
                      <span className="text-xs font-bold uppercase tracking-widest text-white/60">Zona {i + 1}</span>
                    </div>
                    <h3 className="text-xl font-extrabold">{title}</h3>
                    <div className="mt-3 flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      <span className="text-sm font-semibold text-white/80">Cobertura activa</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </section>
  );
}
